var paragraph_default = {
  "fontElementMap": "fKttk",
  "elementSpacing": "GQGT5",
  "text": "_7DyIx GQGT5",
  "child": "_4q3nu"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
